export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_08.7d5642bd.jpg";